module.exports = __webpack_public_path__ + "static/img/fullscreen-image_interested-in-becoming-a-partner_768.d6ede04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/fullscreen-image_interested-in-becoming-a-partner_768.png
// module id = 0kZo
// module chunks = 0